import { Button, Form, Popconfirm, Table } from "antd";
import MainLayouts from "layouts/MainLayouts";
import React, { useEffect, useState } from "react";
import _Api from "services/Api/_Api";
import { TitleBar } from "services/Forms/Forms";
import { Button_, Select_ } from "services/Forms/FormsSatu";
import DataDiet from "./DataDiet";
import { DeleteFilled, DeleteTwoTone, EditFilled, PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import { Row } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { msg } from "services/Toastr/Notify/_Toastr";

function MappDiet({ jenisdiet_id, refresh }) {
    const [listWaktuMakan, setlistWaktuMakan] = useState([]);
    const [listDiet, setlistDiet] = useState([]);
    const [data, setdata] = useState();
    const [dataJenisDiet, setdataJenisDiet] = useState([]);
    const [rowSpanMap, setRowSpanMap] = useState({});

    const history = useHistory()

    const [frm] = Form.useForm();



    const getlistDiet = () => {
        _Api.get("data-diet-master")
            .then((rr) => {
                setlistDiet(rr.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };

    const loadData = (jenisdiet_id = "") => {
        _Api.get("get-data-mapping-diet?jenisdiet_id=" + jenisdiet_id).then((tt) => {
            setdata(tt.data)

        });
    }
    const ubahData = (data) => {
        // debugger
        history.push("/BuatDiet?jenisdiet_id="+data.id + "&jenisdiet="+data.jenisdiet) 
    }

    const hapusMappingDiet = (dt) => {
        _Api.get("hapus-data-diet?diet_id="+ dt.id).then(rr => {
            if (rr.data.sts == "1") {
                msg.auto(rr.data)
                loadData()
            }
            // rr.data.sts == "1" && 
        })
    }

    
    const buatDietBaru = () => {
        history.push("/BuatDiet")
    }


    useEffect(() => {
        getlistDiet();
        // fetchListDiet()
        loadData()
    }, []);

    const columns = [
        {
            title: "No",
            // dataIndex: "waktumakan",
            width: "50px",
            align :"center",
            render: (value, record, index) => {
                return (
                    index + 1
                )
            },
        },
        {
            title: "Jenis Diet",
            dataIndex: "jenisdiet",
            render: (value) => {
                return (
                    <div className="b"> {value} </div>
                )
            }
        },
        {
            title: "Ubah/Hapus",
            width: "200px",
            render: (val, data, i) => {
                return (
                    <div className="b d-flex">
                        <Button icon={<EditFilled />} onClick={()=>ubahData(data)} type="primary"> Ubah </Button>
                        <Popconfirm
                            title="Apakah yakin ingin menghapus?"
                            onConfirm={() => hapusMappingDiet(data)}
                            okText="Ya"
                            cancelText="Batal"
                        >
                            <Button icon={<DeleteFilled />} danger type="primary"> Hapus </Button>
                        </Popconfirm>
                        {/* <Button icon={<DeleteFilled />} danger type="primary"> Hapus </Button> */}
                    </div>
                )
            }
        },

    ];

    return (
        <MainLayouts>
            <br />
            <TitleBar label="Data Diet" />
            <div className="overflow-auto">
                <Form form={frm} layout="vertical" onFinish={loadData}>
                    <Row>

                        <Select_ sm="9"
                            onChange={loadData}
                            label="Nama Diet"
                            name="jenisdiet_id"
                            caption="jenisdiet"
                            val="id"
                            option={listDiet}
                        />
                        <Button_ sm="3" onClick={buatDietBaru} icon={<PlusCircleFilled />} style={{ marginTop: "23px" }} label="Buat Diet Baru" />
                    </Row>
                </Form>
                <Table
                    style={{ minWidth: "800px" }}
                    bordered
                    rowKey={"id"}
                    dataSource={data}
                    size="large"
                    expandable={{
                        expandedRowRender: (rc) => (
                            <div>
                                <DataDiet jenisdiet_id={rc.id} />
                            </div>
                        ),
                    }}
                    columns={columns}
                />
            </div>
        </MainLayouts>
    );
}

export default MappDiet;
